import imageBrightFutureGuy from "./Bright-Future-Guy.jpg";
import imageChintan from "./Chintan.jpg";
import imageElvis from "./Elvis.jpg";
import imageEtty from "./Etty.png";
import imageFarhan from "./Farhan.jpg";
import imageFaruk from "./Faruk.jpg";
import imageMoosa1 from "./Moosa-1.jpeg";
import imageSheetal from "./Sheetal.jpg";
import imageChainforce from "./chainforce-300x84.png";
import imageCoinfabrikr from "./coinfabrikr-300x94.png";
import imageEzgif from "./ezgif.com-gif-maker-300x74.png";
import imageJohn from "./john.jpg";
import imagePimlico from "./pimlico.png";
import imageProtcol1 from "./protcol-1.png";
import imageProtocal1 from "./protocal-1.png";
import imageQuestn1 from "./questn1-300x73.png";
import imageRiahni from "./riahni.jpg";
import imageStreamflow from "./streamflow--300x78.png";
import imageTransak from "./transak.png";
import imageWeb3auth from "./web3auth.png";
import imageAndyWynn from "./Andywynn.jpeg";
import imageZerodevv from "./zerodevv-300x94.png";
import imageCHAINFORCE from "./CHAINFORCE.png"
import benefits1 from "./benitits1.png";
import benefits2 from "./benitits2.png";
import benefits3 from "./benifits3.png";
import benefits4 from "./benifits4.png";
import news1 from "./account-abstraction.jpg";
import protocol1 from "./protocol1.png";
import protocol2 from "./protocol2.png";
import protocol3 from "./protocol3.png";
import protocol4 from "./protocol4.png";
import protocol5 from "./protocol5.png";
import protocol6 from "./protocol6.png";
import dao1 from "./dao1.png";
import dao2 from "./dao2.png";
import dao3 from "./dao3.png";
import mainlogo from "./Transparent Black.png";
import pagenotfound from "./404.png";
import farcaster from "./farcaster.jpg";
import RohanKapse from "./RohanKapse.jpg";
import blokclogo from "./mainlogo1.png";
import BackgroundImage from "./crypto-coins-abstract.png";
import tokenomics1 from "./tokenomics1.png";
import tokenomics2 from "./tokenomics2.png";
import tokenomics3 from "./tokenomics3.png";
import tokenomics4 from "./tokenomics4.png";
import tammy from "./Tammy.jpeg"
import corevalue1 from "./corevalue1.png"
import corevalue2 from "./corevalue2.png"
import corevalue3 from "./corevalue3.png"
import corevalue4 from "./corevalue4.png"



export {
  imageBrightFutureGuy,
  imageChintan,
  imageElvis,
  imageEtty,
  imageFarhan,
  imageFaruk,
    imageMoosa1,
  imageSheetal,
  imageChainforce,
  imageCoinfabrikr,
  imageEzgif,
  imageJohn,
  imagePimlico,
  imageProtcol1,
  imageProtocal1,
  imageQuestn1,
  imageRiahni,
  imageStreamflow,
  imageTransak,
  imageWeb3auth,
  imageAndyWynn,
  imageZerodevv,
  imageCHAINFORCE,
  benefits1,
  benefits2,
  benefits3,
  benefits4,
  news1,
  protocol1,
  protocol2,
  protocol3,
  protocol4,
  protocol5,
  protocol6,
  dao1,
  dao2,
  dao3,
  mainlogo,
  pagenotfound,
  farcaster,
  RohanKapse,
  blokclogo,
  BackgroundImage,
  tokenomics1,
  tokenomics2,
  tokenomics3,
  tokenomics4,
  tammy,
  corevalue1,
  corevalue2,
  corevalue3,
  corevalue4
};
